import { createTheme } from '@material-ui/core';
import colors from '../colors';
var themeFont = 'Roboto, Helvetica, Arial, sans-serif';
var BaseMui = createTheme({
    overrides: {
        MuiCssBaseline: {
            '@global': {},
        },
        MuiOutlinedInput: {
            notchedOutline: {
                color: 'rgb(0, 0, 0, 0.54)',
            },
        },
        MuiFormHelperText: {
            root: {
                fontSize: '0.625rem',
                fontStyle: 'normal',
                fontWeight: 600,
                letterSpacing: 'normal',
                lineHeight: '116.6667%',
            },
        },
        MuiFormLabel: {
            root: {
                fontSize: '0.875rem',
                fontStyle: 'normal',
                fontWeight: 400,
                letterSpacing: 'normal',
                lineHeight: '125%',
            },
        },
        MuiInputBase: {
            root: {
                fontSize: '1rem',
                fontStyle: 'normal',
                fontWeight: 400,
                letterSpacing: 'normal',
                lineHeight: '125%',
            },
            input: {
                '&::placeholder': {
                    opacity: 1,
                    color: 'rgb(0, 0, 0, .54)',
                },
            },
        },
    },
    palette: {
        common: {
            black: colors.black,
            white: colors.white,
        },
        type: 'light',
        primary: {
            light: colors.blue500,
            main: colors.blue600,
            dark: colors.blue700,
            contrastText: colors.white,
        },
        secondary: {
            light: colors.scaleGray500,
            main: colors.scaleGray600,
            dark: colors.scaleGray700,
            contrastText: colors.white,
        },
        error: {
            light: colors.red300,
            main: colors.red600,
            dark: colors.red700,
            contrastText: colors.white,
        },
        warning: {
            light: colors.redOrange300,
            main: colors.redOrange600,
            dark: colors.redOrange700,
            contrastText: colors.white,
        },
        info: {
            light: colors.deepOcean300,
            main: colors.deepOcean600,
            dark: colors.deepOcean700,
            contrastText: colors.white,
        },
        success: {
            light: colors.green300,
            main: colors.green600,
            dark: colors.green700,
            contrastText: colors.white,
        },
        text: {
            primary: colors.scaleGray900,
            secondary: colors.scaleGray600,
            disabled: colors.scaleGray300,
            hint: colors.scaleGray300,
        },
        divider: colors.scaleGray100,
        background: {
            default: colors.scaleGray025,
            paper: colors.white,
        },
        action: {
            disabled: colors.scaleGray300,
            disabledBackground: colors.scaleGray100,
        },
    },
    typography: {
        htmlFontSize: 16,
        fontFamily: themeFont,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 400,
        fontWeightBold: 500,
        h1: {
            fontSize: '2rem',
            fontStyle: 'normal',
            fontWeight: 500,
            letterSpacing: 'normal',
            lineHeight: '150%',
        },
        h2: {
            fontSize: '1.5rem',
            fontStyle: 'normal',
            fontWeight: 500,
            letterSpacing: 'normal',
            lineHeight: '120%',
        },
        h3: {
            fontSize: '1.25rem',
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: 'normal',
            lineHeight: '130%',
        },
        h4: {
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: 'normal',
            lineHeight: '130%',
        },
        h5: {
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: 'normal',
            lineHeight: '130%',
        },
        subtitle1: {
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '130%',
        },
        body1: {
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '130%',
        },
        body2: {
            fontSize: '0.75rem',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '125%',
        },
        button: {
            fontSize: '0.938rem',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '173%',
            letterSpacing: 'normal',
            textTransform: 'none',
        },
        overline: {
            fontSize: '0.75rem',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: 'normal',
            lineHeight: '125%',
            textTransform: 'none',
        },
        caption: {
            fontSize: '0.625rem',
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: 'normal',
            lineHeight: '125%',
        },
    },
});
export default BaseMui;
//# sourceMappingURL=baseMui.js.map